import { baseApi } from './_baseQuery';


export const privacyApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        otpRequest: build.mutation<void, string>({
            query: (request) => ({
                url: "/notifications/verify/request",
                method: 'POST',
                body: {
                    phoneNumber: request
                },
            }),
        }),
        otpVerify: build.mutation<void, { phoneNumber: string, code: string }>({
            query: (body) => ({
                url: "/notifications/verify",
                method: "POST",
                body
            }),
            // invalidatesTags: (_, __, data) => [{ type: 'Recalls', id: data.contactId }]
        }),
    }),
});

export const {
    useOtpRequestMutation,
    useOtpVerifyMutation
} = privacyApi